export default {
    url: '/edit/:id',
    template: `
        <div class="heading01">
            <h1>{{ vm.course.activeI18n.name }}</h1>
            <ul class="actions01">
                <li>
                    <a
                        class="btn bordered02"
                        ng-click="vm.CourseService.openHistoricParticipationModal(vm.course)"
                        ng-if="vm.PrivilegeService.canManageOccurrences()">
                        {{ 'course.Add course participation history' | translate }}
                    </a>
                </li>
            </ul>
        </div>
        <div ng-if="vm.isArchived" class="alert alert-warn ng-scope">
        {{ 'course.Course is archived! No actions can be made while course is archived' | translate }}
        </div>
        <ul class="tabs01">
            <li>
                <a ui-sref="authorized.courses.courses.edit.version.list({id: vm.course.id})"
                    ng-class="{ active: vm.step==3 }"
                >{{ 'courses.Structure' | translate }}</a>
            </li>
            <li>
                <a ui-sref="authorized.courses.courses.edit.general({id: vm.course.id})"
                    ng-class="{ active: vm.step==1 }"
                >{{ 'courses.General data' | translate }}</a>
            </li>
            <li>
                <a ui-sref="authorized.courses.courses.edit.target({id: vm.course.id})"
                    ng-class="{ active: vm.step==2 }"
                >{{ 'courses.Targets' | translate }}</a>
            </li>
            <li>
                <a ui-sref="authorized.courses.courses.edit.occurrence.list({id: vm.course.id})"
                    ng-class="{ active: vm.step==4 }"
                >{{ 'courses.Planning' | translate }}</a>
            </li>
            <li class="f-right" ng-if="vm.CourseService.canManageCourse(vm.course)">
                <courses-courses-translation course="vm.course"></courses-courses-translation>
            </li>
        </ul>
        <ui-view></ui-view>
    `,
    abstract: true,
    controller ($scope, CourseService, PrivilegeService) {
        this.$scope = $scope;
        this.CourseService = CourseService;
        this.PrivilegeService = PrivilegeService;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/index.js